import { Medium14 } from '@/components/design-system';
import styles from './queryWidget.module.scss';
import { QueryWidgetDTO } from './queryWidget.type';
import Link from 'next/link';

const QueryWidget = ({
  contactText = 'For any queries, please reach out to our customer service team ',
  contactMail = '',
}: QueryWidgetDTO) => {
  const mail = contactMail || '';
  return (
    <>
      <div className={styles['contact-con']}>
        <Medium14>{contactText}</Medium14>
        {mail.length ? (
          <Medium14 color="var(--tang-blue-600)">
            <Link href={`mailto:${mail}`}>{mail}</Link>
          </Medium14>
        ) : null}
      </div>
    </>
  );
};

export default QueryWidget;

// import { Medium14, SemiBold14 } from '@/components/design-system';
// import styles from './queryWidget.module.scss';
// import Link from 'next/link';
// import { QueryWidgetDTO } from './queryWidget.type';
//
// const QueryWidget = ({
//   contactText = 'For any queries related to this policy, please write to ',
//   contactMail = 'care@hdfergo.com',
// }: QueryWidgetDTO) => {
//   return (
//     <>
//       <div className={styles['contact-con']}>
//         <Medium14>{contactText}</Medium14>
//         <SemiBold14 color="var(--tang-blue-600)">
//           <Link href={`mailto:${contactMail}`}>{contactMail}</Link>
//         </SemiBold14>
//       </div>
//     </>
//   );
// };
//
// export default QueryWidget;
